import { BaseProps, Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { Form as NewForm } from './new_form'
import { PortfolioPageAttributes } from '@/types'

interface Props extends BaseProps {
  defaultValues?: Partial<PortfolioPageAttributes>
}

export const NewDialog = ({ defaultValues, open, setOpen }: Props) => {
  return (
    <>
      <Dialog open={open} size="3xl" onClose={setOpen}>
        <DialogTitle>New portfolio page</DialogTitle>
        <DialogBody>
          <NewForm defaultValues={defaultValues} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
